import getReplyWithSuggestionsAction from '../actions/getReplyWithSuggestionsAction';
import storeAttachmentSuggestionsOnItemAction from '../actions/storeAttachmentSuggestionsOnItemAction';
import fetchReplyWithSuggestions from '../services/fetchReplyWithSuggestions';
import { AttachmentSuggestions, ClientItem, mailStore } from 'owa-mail-store';
import { orchestrator } from 'satcheljs';

export default orchestrator(getReplyWithSuggestionsAction, async function (actionMessage: {
    referenceItemId: string;
}) {
    const referenceItemId: string = actionMessage.referenceItemId;
    const referenceItem: ClientItem = mailStore.items.get(referenceItemId);

    // Only need to take action if no AttachmentSuggestions object on item.
    if (referenceItem && !referenceItem.AttachmentSuggestions) {
        // No suggestions stored, attempt to fetch.
        const replyWithSuggestions: AttachmentSuggestions = await fetchReplyWithSuggestions(
            referenceItem
        );

        storeAttachmentSuggestionsOnItemAction(referenceItemId, replyWithSuggestions);
    }
});
